import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import api from '../../services/api_despesas';
import stylesIndex from "./index-styles.module.css";
import { MdDesktopAccessDisabled } from 'react-icons/md'

export default function Organograma() {

    const [perfis, setPerfis] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [loading, setLoading] = useState(true);

    let history = useHistory();

    useEffect(() => {
        api.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data.usuario_perfil && response.data.usuario_modulo) {
                setPerfis(response.data.usuario_perfil);
                setModulos(response.data.usuario_modulo);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(() => {
            setLoading(false);
        });
    }, []);

    function handleManutencaoPrevisoes() {
        history.push('/manutencaoprevisoes', {hasAccess: true});
    }

    function renderManutecaoPrevisoes() {
        if(perfis.find(({ perfil_id }) => perfil_id === 5)) {
            return (
                <>
                    <hr />
                    <h4 className={stylesIndex.optionstitle}>MANUTENÇÕES</h4>
                    <div className={stylesIndex.optionsconteiner}>
                        <input type="button" className={stylesIndex.optionsbutton} value="MANUTENÇÃO DE PREVISÕES" onClick={() => handleManutencaoPrevisoes()} />
                    </div>
                </>
            )
        }
    }

    function handlePrevisaoAtual(status) {
        history.push('/previsao', {status: status, hasAccess: true});
    }

    function renderPrevisaoAtual() {
        return (
            <>
                <h4 className={stylesIndex.optionstitle}>PREVISÃO ATUAL</h4>
                <div className={stylesIndex.optionsconteiner}>
                    <input type="button" className={stylesIndex.optionsbutton} value="PREVISÃO EM ABERTO" onClick={() => handlePrevisaoAtual(0)} />
                    <input type="button" className={stylesIndex.optionsbutton} value="PREVISÃO EM EXECUÇÃO" onClick={() => handlePrevisaoAtual(1)} />
                </div>
            </>
        )
    }

    function renderOptions() {
        if(!loading) {
            if(perfis.find(({ perfil_id }) => perfil_id === 10) && modulos.find(({ modulos_id }) => modulos_id === 17)) {
                return (
                    <>
                        {renderPrevisaoAtual()}
                        {renderManutecaoPrevisoes()}
                    </>
                )
            } else {
                return (
                    <>
                        <MdDesktopAccessDisabled style={{width: '100%', maxWidth: '200px', height: 'auto'}}/>
                        <div className={stylesIndex.optionstitle}>
                            VOCÊ NÃO TEM ACESSO A ESSE MÓDULO!
                        </div>
                    </>
                )
            }
        }
    }

    return (
        <div className="container-lg">
            <Header title="ORGANOGRAMA" />
            {renderOptions()}
        </div>
    )
}